import Container from "react-bootstrap/Container";
import RetailLeadForm from "../../calculators/retailLeadForm";
import Button from "react-bootstrap/Button";
import { Row, Col, Card, Form } from "react-bootstrap";
import Faq from "../../components/Faq";
import "../../styles/dualEducation.css";
import "../../styles/sliderCalculator.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

const PERSONAL_LOAN_ILLUSTRATIVE_APR = 15.9;

function annuityPayment(principal, annualRatePct, months) {
  const r = annualRatePct / 100 / 12;
  if (r === 0) return principal / months;
  return (principal * r) / (1 - Math.pow(1 + r, -months));
}

export default function SzemelyiKolcson() {
  const [amount, setAmount] = useState(2_000_000);
  const [term, setTerm] = useState(36);
  const [income, setIncome] = useState("");

  const monthlyRepayment = annuityPayment(
    amount,
    PERSONAL_LOAN_ILLUSTRATIVE_APR,
    term,
  );

  const jtmHint =
    income !== "" && Number(income) > 0
      ? `A becsült törlesztő a megadott nettó jövedelmed kb. ${(
          (monthlyRepayment / Number(income)) *
          100
        ).toFixed(
          0,
        )}%-a. Tájékoztató jelleggel: a JTM-szabályok szerint ez az arány jellemzően 50-60% alatt maradhat elfogadható a bankok számára, jövedelemtől és meglévő hitelektől függően.`
      : "Add meg a nettó havi jövedelmed, hogy lásd a törlesztő becsült jövedelemarányát (JTM).";

  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">SZEMÉLYI KÖLCSÖN • ÖSSZEHASONLÍTÁS • 2026</span>

        <h1 className="title">
          Személyi kölcsön <br />
          <span style={{ color: "#c7d2fe" }}>
            összehasonlítás és kalkulátor
          </span>
        </h1>

        <p className="subtitle">
          A személyi kölcsön szabad felhasználású hitel, amelyet fedezet nélkül,
          jellemzően 300 000-10 000 000 forint között, 6-84 hónapos futamidőre
          nyújtanak a magyar bankok; a THM 2026-ban a hitelösszegtől,
          futamidőtől és az ügyfél KHR-hiteltörténetétől függően nagyjából 9-25%
          között mozog.
          <br />
          <span className="fw-bold">
            Számold ki a várható havi törlesztőt, és kérj személyre szabott
            ajánlatot!
          </span>
        </p>

        <div className="cta">
          <Button href="#calculation" className="btn btn-primary">
            Kalkulátor
          </Button>

          <Button href="#leadform" className="btn btn-secondary">
            Ajánlatot kérek
          </Button>
        </div>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-4">
            <Col md={4}>
              <Card className="card">
                <div className="kpi">9-25%</div>
                <div className="muted">Illusztratív THM tartomány</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">300e-10M Ft</div>
                <div className="muted">Igényelhető hitelösszeg</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">1-3 nap</div>
                <div className="muted">Jellemző bírálati idő</div>
              </Card>
            </Col>
          </Row>
        </section>

        <Container id="calculation">
          <h2 className="h2 mt-5">Személyi kölcsön kalkulátor</h2>
          <section className="slider-calculator section p-0">
            <div className="calculator-wrapper">
              <h3 className="h4">
                Hitelösszeg:{" "}
                <span className="number">{amount.toLocaleString()}</span> Ft
              </h3>
              <input
                type="range"
                min={300_000}
                max={10_000_000}
                step={100_000}
                value={amount}
                onChange={(e) => setAmount(Number(e.target.value))}
                className="slider"
              />

              <h3 className="h4 mt-4">
                Futamidő: <span className="number">{term}</span> hónap
              </h3>
              <input
                type="range"
                min={6}
                max={84}
                step={6}
                value={term}
                onChange={(e) => setTerm(Number(e.target.value))}
                className="slider"
              />

              <Form.Group className="mt-4" style={{ textAlign: "left" }}>
                <Form.Label className="mb-1 fw-bold">
                  Nettó havi jövedelem (opcionális, a JTM-becsléshez)
                </Form.Label>
                <Form.Control
                  type="number"
                  inputMode="numeric"
                  placeholder="pl. 450000"
                  value={income}
                  onChange={(e) =>
                    setIncome(
                      e.target.value === "" ? "" : Number(e.target.value),
                    )
                  }
                  style={{ maxWidth: "300px" }}
                />
                <p className="small mt-2">{jtmHint}</p>
              </Form.Group>

              <div className="revenue-block">
                <div className="row">
                  <Col md={12}>
                    <div className="revenue-text">
                      Becsült havi törlesztőrészlet*:
                    </div>
                    <div className="revenue-value">
                      <strong>
                        {Math.round(monthlyRepayment).toLocaleString()} Ft / hó
                      </strong>
                    </div>
                  </Col>
                </div>
                <div className="disclaimer mt-3">
                  *Illusztratív becslés, {PERSONAL_LOAN_ILLUSTRATIVE_APR}%-os
                  illusztratív THM-mel számolva, ami nem konkrét banki ajánlat.
                  A valós THM bankonként és profilonként eltérhet.
                </div>
              </div>
            </div>
            <div className="text-center mt-5">
              <Button href="#leadform" className="btn btn-primary">
                Pontos ajánlatot kérek
              </Button>
            </div>
          </section>
        </Container>

        <section id="folyamat" className="section">
          <h2 className="h2">Így működik a személyi kölcsön igénylése</h2>
          <div className="steps-container mt-4">
            <Row className="g-4">
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">1</div>
                <p className="fw-bold">Adatok megadása</p>
                <p className="small">
                  Hitelösszeg, futamidő, opcionálisan jövedelem
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">2</div>
                <p className="fw-bold">Becslés megtekintése</p>
                <p className="small">
                  Azonnal látod az illusztratív havi törlesztőt
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">3</div>
                <p className="fw-bold">Ajánlatkérés</p>
                <p className="small">
                  Elérhetőséged megadása, továbbítjuk a kiválasztott bankoknak
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">4</div>
                <p className="fw-bold">Összehasonlítás és döntés</p>
                <p className="small">
                  A beérkező ajánlatok közül te döntesz, kötelezettség nélkül
                </p>
              </Col>
            </Row>
          </div>
        </section>

        <Container id="leadform">
          <h2 className="h2">Kérjen ajánlatot még ma!</h2>
          <p className="lead small">
            Add meg az adataid, és hamarosan visszajelzünk a személyi kölcsön
            lehetőségeidről!
          </p>
          <Row>
            <Col md={4}>
              <RetailLeadForm leadType="Personal_loan" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Díjmentes ügyintézés</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Gyors, 1-3 napos bírálat</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Több bank ajánlata egy helyen</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Segítség KHR-bejegyzés esetén is</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question:
                      "Mi számít jó THM-nek személyi kölcsönnél 2026-ban?",
                    answer:
                      "2026-ban egy 1-3 millió forintos, 36 hónapos személyi kölcsönnél a 10-15% közötti THM tekinthető versenyképesnek jó hiteltörténet mellett; 18% felett érdemes más bankok ajánlatát is megnézni. A THM mindig tartalmazza a kamatot és a legtöbb díjat is, ezért ez az elsődleges összehasonlítási alap, nem a hirdetett kamat.",
                  },
                  {
                    question: "Felvehetek személyi kölcsönt KHR-bejegyzéssel?",
                    answer:
                      "Aktív, negatív (B) KHR-listás státusszal a legtöbb hazai bank elutasítja a hiteligénylést, mivel a KHR-ellenőrzés kötelező eleme a bírálatnak. Lezárt, passzív KHR-bejegyzés esetén egyes bankok és pénzügyi vállalkozások továbbra is mérlegelik a kérelmet, magasabb kamat vagy alacsonyabb hitelösszeg mellett.",
                  },
                  {
                    question:
                      "Mennyi idő alatt bírálják el a személyi kölcsön kérelmet?",
                    answer:
                      "A legtöbb banknál a teljes online igénylési folyamat, a dokumentumfeltöltéstől a szerződéskötésig, 1-3 munkanapot vesz igénybe, hiánytalan papírok esetén. A folyósítás jellemzően a szerződés aláírását követő 1-2 munkanapon belül megtörténik, banki munkarendtől függően.",
                  },
                  {
                    question:
                      "Van különbség a szabad felhasználású és a hitelkiváltó kölcsön THM-je között?",
                    answer:
                      "Igen: a hitelkiváltó (más hitel kiváltására szánt) személyi kölcsönök THM-je jellemzően 1-3 százalékponttal alacsonyabb, mert a bank kockázata alacsonyabb, és sok intézmény kedvezményt ad a meglévő hitel kiváltására. Szabad felhasználásnál nincs ilyen automatikus kedvezmény.",
                  },
                  {
                    question:
                      "Milyen dokumentumok kellenek a személyi kölcsön igényléséhez?",
                    answer:
                      "Személyazonosító igazolvány, lakcímkártya és adókártya mellett jövedelemigazolás szükséges (munkáltatói igazolás vagy 3-6 havi bankszámlakivonat), valamint a bank saját igénylőlapja. Meglévő hitel kiváltásához a futó szerződés és az aktuális egyenlegigazolás is szükséges.",
                  },
                ],
              },
            ]}
          />

          <p className="small mt-4">
            A fenti kalkulátor illusztratív becslést ad, nem minősül
            hitelbírálatnak vagy ajánlattételnek. A Financials.hu nem
            hitelintézet; a végleges kondíciókat a kiválasztott bank
            hitelbírálata határozza meg. Az oldalon feltüntetett THM-tartományok
            forrása a bankok hivatalos hirdetménye és az MNB nyilvános
            adatbázisa.
          </p>
        </section>
      </Container>
    </>
  );
}
